"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var designer_content_layout_model_1 = require("../../../layout-models/designer-content-layout.model");
var designer_layout_row_model_1 = require("../../../layout-models/designer-layout-row.model");
var layout_tab_model_1 = require("../../../layout-models/layout.tab.model");
var abstract_destruction_subject_1 = require("../../../utils/abstract-destruction-subject");
var layout_utils_1 = require("../../../utils/layout-utils");
require("./layout-tabs.component.scss");
var tab_delete_popup_component_1 = require("./tab-delete-popup.component");
var LayoutTabsComponent = /** @class */ (function (_super) {
    __extends(LayoutTabsComponent, _super);
    function LayoutTabsComponent(languageService, currentLanguageProvider, dialog) {
        var _this = _super.call(this) || this;
        _this.languageService = languageService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.dialog = dialog;
        _this.tabs = [];
        _this.onSelectEmitter = new core_1.EventEmitter();
        _this.tabBarRemoveEmitter = new core_1.EventEmitter();
        _this.tabBarExists = false;
        _this.isReady = false;
        _this.tabRenaming = false;
        return _this;
    }
    Object.defineProperty(LayoutTabsComponent.prototype, "onSelect", {
        get: function () {
            return this.onSelectEmitter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutTabsComponent.prototype, "tabBarRemoveEvent", {
        get: function () {
            return this.tabBarRemoveEmitter;
        },
        enumerable: true,
        configurable: true
    });
    LayoutTabsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var languages$ = this.languageService.getAvailableLanguages();
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        zip_1.zip(languages$, currentLanguage$)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            _this.languages = data[0];
            _this.currentLanguage = data[1];
            _this.isReady = true;
        }, console.error);
        this.tabOptions = {
            direction: 'horizontal',
            copy: false,
            accepts: function (el, target, source, sibling) {
                return sibling !== null;
            },
            moves: function (el, source, handle, sibling) {
                return el.id !== 'form-designer-new-tab';
            },
        };
    };
    LayoutTabsComponent.prototype.selectTab = function (tab) {
        if (tab.tabId !== this.currentTab.tabId) {
            this.currentTab = tab;
            this.onSelectEmitter.emit(tab);
            this.tabRenaming = false;
        }
    };
    LayoutTabsComponent.prototype.addNewTab = function () {
        var newId = layout_utils_1.LayoutUtils.uniqueId();
        var newTab = new layout_tab_model_1.LayoutTabModel(newId, new designer_content_layout_model_1.DesignerContentLayoutModel(), this.initTabTitle());
        this.tabs.push(newTab);
        this.renameTab(newTab);
    };
    LayoutTabsComponent.prototype.tabJustDropped = function (layout) {
        var newId = layout_utils_1.LayoutUtils.uniqueId();
        var newTab = new layout_tab_model_1.LayoutTabModel(newId, layout, this.initTabTitle(true));
        this.tabs.push(newTab);
        this.tabBarExists = true;
        this.currentTab = newTab;
    };
    LayoutTabsComponent.prototype.tabEditMode = function (tabs) {
        this.tabs = tabs;
        this.tabBarExists = true;
        this.currentTab = this.tabs[0];
    };
    LayoutTabsComponent.prototype.initTabTitle = function (justDropped) {
        if (justDropped === void 0) { justDropped = false; }
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        this.languages.forEach(function (language) {
            var languageId = language.getId();
            if (justDropped) {
                multilingualStringBuilder.withValueForLanguage(languageId, 'General');
            }
            else {
                multilingualStringBuilder.withValueForLanguage(languageId, '');
            }
        });
        return multilingualStringBuilder.build();
    };
    LayoutTabsComponent.prototype.openDialog = function (tabIdToDelete) {
        var _this = this;
        var dialogRef = this.dialog.open(tab_delete_popup_component_1.TabDeletePopupComponent, {
            height: '200px',
        });
        dialogRef
            .afterClosed()
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (result) {
            if (result['acceptDelete'] && result['deleteContent']) {
                _this.deleteTabWithContent(tabIdToDelete);
            }
            else if (result['acceptDelete'] && !result['deleteContent']) {
                _this.deleteTabWithMergingContent(tabIdToDelete);
            }
        }, console.error);
    };
    LayoutTabsComponent.prototype.renameTab = function (tab) {
        if (tab.tabId !== this.currentTab.tabId) {
            this.selectTab(tab);
        }
        this.tabRenaming = true;
        this.tempTitle = this.prepareTitleRenaming(this.currentTab.title);
    };
    LayoutTabsComponent.prototype.confirmRename = function () {
        this.tabRenaming = false;
        this.currentTab.title = this.tempTitle;
        if (this.isTitleEmpty()) {
            this.deleteTabWithContent(this.currentTab.tabId);
        }
    };
    LayoutTabsComponent.prototype.prepareTitleRenaming = function (title) {
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        this.languages.forEach(function (language) {
            var languageId = language.getId();
            multilingualStringBuilder.withValueForLanguage(languageId, title.getValue(languageId));
        });
        return multilingualStringBuilder.build();
    };
    LayoutTabsComponent.prototype.trackByFunc = function (index, tab) {
        return tab.tabId;
    };
    LayoutTabsComponent.prototype.isTitleEmpty = function () {
        var _this = this;
        return !this.languages.find(function (language) {
            return (_this.currentTab.title &&
                _this.currentTab.title.getValue(language.getId()) !== null &&
                _this.currentTab.title.getValue(language.getId()) !== '');
        });
    };
    LayoutTabsComponent.prototype.deleteTabWithContent = function (tabId) {
        var indexToDelete = this.tabs.findIndex(function (tab) {
            return tab.tabId === tabId;
        });
        this.checkCurrentTabAfterTabDelete(tabId, indexToDelete);
        if (indexToDelete >= 0) {
            this.tabs.splice(indexToDelete, 1);
        }
        this.checkIfTabBarNeeded();
    };
    LayoutTabsComponent.prototype.deleteTabWithMergingContent = function (tabId) {
        var _this = this;
        var indexToDelete = this.tabs.findIndex(function (tab) {
            return tab.tabId === tabId;
        });
        this.checkCurrentTabAfterTabDelete(tabId, indexToDelete);
        if (indexToDelete >= 0) {
            var layoutToMergeFrom = this.tabs[indexToDelete].tabLayout;
            if (indexToDelete === 0) {
                if (this.tabs.length > 1) {
                    layoutToMergeFrom.layoutRows.map(function (cardRow) {
                        var newRow = new designer_layout_row_model_1.DesignerLayoutRowModel(cardRow.cards);
                        newRow.id = cardRow.id;
                        _this.tabs[1].tabLayout.addRowOfCards(newRow);
                    });
                }
            }
            else {
                layoutToMergeFrom.layoutRows.map(function (cardRow) {
                    var newRow = new designer_layout_row_model_1.DesignerLayoutRowModel(cardRow.cards);
                    newRow.id = cardRow.id;
                    _this.tabs[indexToDelete - 1].tabLayout.addRowOfCards(newRow);
                });
            }
            if (this.tabs.length > 1) {
                this.tabs.splice(indexToDelete, 1);
            }
        }
        this.checkIfTabBarNeeded();
    };
    LayoutTabsComponent.prototype.checkCurrentTabAfterTabDelete = function (tabIdToDelete, indexOfTabToDelete) {
        if (tabIdToDelete === this.currentTab.tabId) {
            if (indexOfTabToDelete === 0) {
                if (this.tabs.length > 1) {
                    this.selectTab(this.tabs[1]);
                }
            }
            else {
                this.selectTab(this.tabs[indexOfTabToDelete - 1]);
            }
        }
    };
    LayoutTabsComponent.prototype.checkIfTabBarNeeded = function () {
        // TODO(Ed): delete tabs when tabs count < 1
        if (this.tabs && this.tabs.length <= 1) {
            this.tabBarExists = false;
            this.tabBarRemoveEmitter.emit(this.tabs[0]);
            this.tabs = [];
        }
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [])
    ], LayoutTabsComponent.prototype, "onSelect", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [])
    ], LayoutTabsComponent.prototype, "tabBarRemoveEvent", null);
    LayoutTabsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'layout-tabs',
            template: require('./layout-tabs.component.html'),
        }),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.LanguageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            material_1.MatDialog])
    ], LayoutTabsComponent);
    return LayoutTabsComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.LayoutTabsComponent = LayoutTabsComponent;
//# sourceMappingURL=layout-tabs.component.js.map